import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '@components/Button'
import Input from '@components/Input'

interface PasswordSigninProps {
  onPasswordSignin: (email: string, password: string) => Promise<boolean>
}
export default function PasswordSignin({ onPasswordSignin }: PasswordSigninProps) {
  const { t } = useTranslation()
  const { schoolSlug } = useParams()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isPending, setIsPending] = useState(false)

  async function handleSigninAttempt() {
    setIsPending(true)
    const success = await onPasswordSignin(email, password)
    if (!success) {
      setPassword('')
    }
    setIsPending(false)
  }

  return (
    <div className='flex flex-col gap-4 justify-center items-center h-full'>
      <div className='w-full'>
        <Input
          type='email'
          label={t('content.components.input_contact.email_field_title')}
          value={email}
          onInput={setEmail}
          placeholder={t('content.components.input_contact.email_field_placeholder')}
        />
      </div>
      <div className='w-full'>
        <Input
          type='password'
          label={t('content.components.signin.password.password_field_title')}
          value={password}
          onInput={setPassword}
          placeholder={t('content.components.signin.password.password_field_placeholder')}
        />
      </div>

      <Button
        variant={'cta'}
        label={t('content.components.signin.button_title')}
        fullwidth
        onClick={handleSigninAttempt}
        disabled={!email || !password || isPending}
      />

      <Link to={`/${schoolSlug}/forgot-password`} className='text-cta hover:text-cta-active hover:underline'>
        {t('content.components.signin.password.forgot_password')}
      </Link>
    </div>
  )
}
